import Retool from 'react-retool';
import { useLocation } from 'react-router';

import { RETOOL_COMMON_PROPS, RETOOL_URLS } from '@/config/retool';

const RETOOL_URL_MAP: Record<string, string> = {
  '/fund-management/allocations': RETOOL_URLS.investments.allocations,
  '/fund-management/funds': RETOOL_URLS.investments.funds,
  '/fund-management/relative-value': RETOOL_URLS.investments.rva,
  '/investments/direct': RETOOL_URLS.investments.direct,
  '/investments/pipelines': RETOOL_URLS.investments.pipelines,
  '/investments/secondary': RETOOL_URLS.investments.secondary
};

const Investments = () => {
  const location = useLocation();
  const retoolUrl =
    RETOOL_URL_MAP[location.pathname] || RETOOL_URLS.investments.direct;

  const retoolData = {
    isEmbedded: true
  };

  return (
    <div className="h-full w-full bg-white dark:bg-gray-900">
      <Retool
        data={retoolData}
        url={retoolUrl}
        {...RETOOL_COMMON_PROPS}
      />
    </div>
  );
};

export default Investments;
